import { CHAT_INIT, CHAT_RESET, SET_MESSAGE, SET_DISCONNECT } from './chat-constants'

export const initChat = payload => ({ type: CHAT_INIT, payload })

export const resetChat = () => ({ type: CHAT_RESET })

export const setDisconnect = () => ({ type: SET_DISCONNECT })

export const setMessagesAction = payload => ({ type: SET_MESSAGE, payload })
